/**
 * The sunrise and sunset the elevation profile shows for the day being
 * looked at — the selected route's day, or the only day when nothing is
 * selected. An overview of several days has no one day to show. Pure.
 */

interface DayStatsLike {
  [day: number]: { sunrise?: Date | null; sunset?: Date | null } | undefined;
}

export function elevationSunDay(activeRoute: { day?: number } | null | undefined, dayCount: number): number | null {
  if (activeRoute) return activeRoute.day ?? 1;
  return dayCount <= 1 ? 1 : null;
}

export function formatSunTime(date: Date): string {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
}

export function sunTimesForDay(dayStats: DayStatsLike | null | undefined, dayNumber: number | null): { sunrise: string; sunset: string } | null {
  if (dayNumber == null) return null;
  const stats = dayStats?.[dayNumber];
  if (!stats?.sunrise || !stats?.sunset) return null;
  return { sunrise: formatSunTime(stats.sunrise), sunset: formatSunTime(stats.sunset) };
}
